import { IUserLoginPayload } from "../../../types/api/user";
import { useUserLogin } from "../../../hooks/api/user/hooks";
import { Button, Col, Form, Input, message, Row } from "antd";
import { setUserData } from "../../../lib/utils";
export default function Login() {
  const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

  const { mutate, isPending } = useUserLogin({
    onSuccess: (res) => {
      setUserData(res.data)
      window.location.reload();

    },
    onError: (err) => {
      // handle error if needed    
      messageApi.error(err.message || 'Login failed');
      // form.resetFields();
    },
  });

  return (
    <div
      className="bg-cover bg-center bg-no-repeat flex justify-center items-center h-screen"
      style={{ backgroundImage: "url('/new-img/login-bg.jpg')" }}
      >
      {contextHolder}
      <div className="bg-white/20 shadow-lg rounded-xl w-full max-w-xs sm:max-w-md p-3 sm:p-4">
          <div className="p-4 bg-white rounded-xl  h-full">
          <div className="w-full flex justify-center rounded-xl items-cente p-1">
            <img src="/new-img/newLogo.png" alt="" className="h-20 w-20 object-cover" />
          </div>

          <div className="w-full flex justify-center flex-col">
            <h1 className=" text-lg sm:text-xl mb-4 text-center">
              Hello <span className="text-primary font-medium">Admin</span>
            </h1>

            <Form
              form={form}
              layout="vertical"
              size="large"
              onFinish={(values: IUserLoginPayload) => mutate(values)}
            >
              <Row>
                <Col span={24}>
                  <Form.Item name="code" rules={[{ required: true, message: "Username is required" }]}>
                    <Input placeholder="User Name"  />
                  </Form.Item>
                </Col>

                <Col span={24} >
                  <Form.Item name="password" rules={[{ required: true, message: "Password is required" }]}>
                    <Input.Password placeholder="Password"  />
                  </Form.Item>
                </Col>

                <Col span={24} className="">
                  <Button
                    className="bg-primary text-white hover:text-white"
                    htmlType="submit"
                    block
                    loading={isPending}
                  >
                    Login
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
